import { PlusOutlined } from '@ant-design/icons';
import {
  Breadcrumb, Button, Col, DatePicker, Form, Input,
  message,
  Row,
  Select,
  Table,
} from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDieToolDetails, fetchToolByProfileId } from '../../slices/die-tool';
import BilletPlanningTable from '../../Common/BilletPlanningTable';
import dayjs from 'dayjs';
import {
  fetchDiePressList,
  resetCurrentDiePressPage,
  resetDiePressList,
} from '../../slices/die-press';
import { fetchPlanningById, editPlanning } from '../../slices/Planning';
import { fetchAgeingOptionsById } from '../../slices/Planning';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
const { Option } = Select;

function EditPlanning() {
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [toolList, setToolList] = useState([]);
  const [agingResponse, setAgeingResponse] = useState(null);
  const [cycleResponse, setCycleResponse] = useState(false);

  const [searchGroup, setSearchGroup] = useState('');
  const [dieType, setDieType] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();


  const [searchDiePress, setSearchDiePress] = useState('');
  const {
    list: diePressList,
    loading: diePressLoading,
    currentpage: diePressCurrentPage,
    hasMore: diePressHasMore,
  } = useSelector(state => state.diePress);
  const [planQtyInput, setPlanQtyInput] = useState('');
  const programmaticUpdate = useRef(false);

  const [toolStatus, setToolStatus] = useState({
    cavity: 0,
    Wtkgmt: 0,
    press: 0,
  });

  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null); // Store selected row data
  const [pressValue, setSelectedPressValue] = useState(null);
  const [agingOptions, setAgingOptions] = useState([]);
  const [plannigData, setPlannigData] = useState([]);
  const [selectedPress, setSelectedPress] = useState(null);

  useEffect(() => {
    dispatch(fetchAgeingOptionsById({}));

    dispatch(fetchDiePressList({ page: 1, pagesize: 5000 }));

    dispatch(resetDiePressList());
  }, [dieType, page, pagesize, search, orderBy]);

  const fetchDieToolList = async id => {
    try {
      const response = await dispatch(
        fetchToolByProfileId({
          id: id,
          page: 1,
          pagesize: 10,
          search: '',
          ordering: '',
        }),
      );
      setToolList(response?.payload?.data || []);
    } catch (error) {
      console.error('Error updating work order:', error);
    }
  }
  useEffect(() => {
    const fetchPlanning = async () => {
      try {
        const response = await dispatch(fetchPlanningById(id)).unwrap();

        if (response) {
          setPlannigData(response?.data);
          const responsedData = response.data;

          const profileNo = responsedData?.profile_no?.die_number;
          const profileId = responsedData?.profile_no?.id;
          const workOrderId = responsedData?.workorder?.id;
          const workorderLabel = [
            responsedData?.workorder?.order_no,
            responsedData?.workorder?.order_date,          // if exists
            responsedData?.workorder?.purchase_order_no,
            responsedData?.workorder?.purchase_order_date,
            responsedData?.customer_name,      // if exists
          ].filter(Boolean).join(' - ');
          const alloyId = responsedData?.workorder.work_order_details[0].alloy?.id;
          const alloyLabel = responsedData?.workorder.work_order_details[0].alloy?.alloy_code;
          const temperId = responsedData?.workorder.work_order_details[0].temper?.id;
          const temperLabel = responsedData?.workorder.work_order_details[0]?.temper?.temper_code_new;
          form.setFieldsValue({
            profile_no: { value: profileId, label: profileNo },
            workorder: { value: workOrderId, label: workorderLabel },
            tool_number: responsedData.die_tool.id,
            cut_length: responsedData.workorder.work_order_details[0].length,
            workorder_date: dayjs(responsedData.workorder.order_date, 'YYYY-MM-DD') || null,
            planning_date: dayjs(responsedData.planning_date, 'YYYY-MM-DD') || null, // Adjust format as needed
            alloy: { value: alloyId, label: alloyLabel },
            temper: { value: temperId, label: temperLabel },
            last_wt_mtr: responsedData.profile_no.wt_kg_p_mt,
            order_pcs: responsedData.workorder.work_order_details[0].pieces,
            order_qty: responsedData.workorder.work_order_details[0].net_weight,
            customer_name: responsedData.workorder.bill_to.customer_name,
            plan_pcs: responsedData.plan_pcs || null,
            plan_qty: responsedData.plan_qty || null,
            quenching_type: responsedData?.quenching_type,
            aging_value: responsedData.aging || null,
            die_type: responsedData.profile_no.die_type || null,
            cutLength: responsedData.workorder.cut_length || null,
            color_code: responsedData?.workorder.work_order_details[0]?.alloy?.alloy_code + ' ' + responsedData?.workorder.work_order_details[0]?.alloy?.standard_name || null,
            cavity: responsedData.die_tool.die_cavity || null,
            eligible_for_press: responsedData.die_tool.eligible_for_press
              ? { label: responsedData.die_tool.eligible_for_press.name, value: responsedData.die_tool.eligible_for_press.id }
              : undefined,
          });

          if (profileId) {
            fetchDieToolList(profileId)
            handleSelectTool(responsedData?.die_tool)
          }


        }
      } catch (error) {
        message.error('Error fetching planning', error);
      }
    };

    fetchPlanning();
  }, [id, form, dispatch, fetchPlanningById]);


  useEffect(() => {
    if (plannigData?.selected_row && tableData.length > 0) {
      const matchedRow = tableData.find(row =>
        row.bit_size === plannigData.selected_row.billet_size
      );

      if (matchedRow) {
        setSelectedRowKeys([matchedRow.id]);
        setSelectedRowData(matchedRow);
      }
    }
  }, [plannigData, tableData]);

  


  const onFinish = async values => {
    try {

      const payload = {
        profile_no: values?.profile_no?.value,
        plan_pcs: Number(values.plan_pcs),
        plan_qty: Number(values.plan_qty),
        workorder_detail_id: plannigData?.workorder_detail,
        workorder: values?.workorder?.value,
        quenching_type: values?.quenching_type,
        water_pressure: values?.water_pressure,
        flow_rate: values?.flow_rate
      };
      const selectedRow = selectedRowData || {};
      payload.selected_row = selectedRow;
      payload.aging = values.aging_value || null;
      payload.die_tool = values.tool_number || null;
      
      const result = await dispatch(
        editPlanning({
          SizeId: id,
          SizeData: payload,
        })
      ).unwrap();

      if (result.success) {
        message.success('Planning updated successfully!');
        navigate('/planning-list');
      } else {
        message.error(result.message || 'Failed to update planning.');
      }
    } catch (error) {
      message.error(error.message || 'An error occurred while updating planning.');
    }
  };

  const handleConversionChange = (field, value) => {
    let currentKg = parseFloat(form.getFieldValue('last_wt_mtr')) || 0;
    let currentCutLength = parseFloat(form.getFieldValue('cut_length')) || 0;
    let orderPcs = parseFloat(form.getFieldValue('order_pcs')) || 0;
    let orderQty = parseFloat(form.getFieldValue('order_qty')) || 0;

    value = !isNaN(parseFloat(value)) ? parseFloat(value) : 0;

    if (field === 'plan_pcs') {
      if (value === orderPcs) {
        form.setFieldsValue({
          plan_qty: orderQty.toFixed(3),
        });
      } else if (currentKg > 0 && currentCutLength > 0 && value > 0) {
        const calculatedNetWeight = ((currentKg * currentCutLength) / 1000) * value;
        form.setFieldsValue({
          plan_qty: calculatedNetWeight.toFixed(3),
        });
      } else {
        form.setFieldsValue({
          plan_qty: '0.000',
        });
      }
    }

    if (field === 'plan_qty') {
      if (value === orderQty) {
        form.setFieldsValue({
          plan_pcs: orderPcs.toString(),
        });
      } else if (currentKg > 0 && currentCutLength > 0 && value > 0) {
        const calculatedPieces = value / (currentKg * (currentCutLength / 1000));
        form.setFieldsValue({
          plan_pcs: Math.round(calculatedPieces).toString(),
        });
      } else {
        form.setFieldsValue({
          plan_pcs: '0',
        });
      }
    }
  };

  const rowSelection = {
    type: 'radio',
    selectedRowKeys,
    onChange: (selectedKeys, selectedRows) => {
      setSelectedRowKeys(selectedKeys.slice(-1));
      setSelectedRowData(selectedRows[0] || null);
    },
    getCheckboxProps: record => ({
      disabled: false,
    }),
  };

  const handleFormChange = (changedValues, allValues) => {
    // if (allValues?.cut_length && allValues?.plan_qty && allValues?.plan_pcs && allValues?.last_wt_mtr && allValues?.cavity && allValues?.tool_number) {
    //   const newData = generateRange(
    //     allValues?.cut_length,
    //     allValues?.plan_pcs,
    //     allValues?.last_wt_mtr,
    //     allValues?.cavity,
    //     allValues?.eligible_for_press?.label
    //   );
    //    console.log("newData in form change", newData)
    //   setTableData(newData);
    // }
  };

  const columns = [
    {
      title: 'BLT SIZE',
      dataIndex: 'bit_size',
      key: 'bit_size',
    },
    {
      title: 'BLT WT',
      dataIndex: 'bit_wt',
      key: 'bit_wt',
    },
    {
      title: 'BUTT WT',
      dataIndex: 'butt_wt',
      key: 'butt_wt',
    },
    {
      title: 'ACT WT',
      dataIndex: 'act_wt',
      key: 'act_wt',
    },
    {
      title: 'EXT LEN',
      dataIndex: 'ext_len',
      key: 'ext_len',
    },
    {
      title: 'PCS / BLT',
      dataIndex: 'pcs_bit',
      key: 'pcs_bit',
    },
    {
      title: 'NET OUT',
      dataIndex: 'net_out',
      key: 'net_out',
    },
    {
      title: 'PROCESS RECOVERY',
      dataIndex: 'process_recovery',
      key: 'process_recovery',
      render: (value) => {
        const num = parseFloat(value);
        let color = 'inherit';
        if (num <= 100 && num > 75) {
          color = 'green';
        } else if (num <= 75 && num > 50) {
          color = 'orange';
        } else if (num <= 50 && num > 25) {
          color = 'red';
        }
        return <span style={{ color }}>{value} %</span>;
      },
    },
    {
      title: 'TOTAL WASTAGE',
      dataIndex: 'total_wastage',
      key: 'total_wastage',
    },
    {
      title: 'TOTAL BLT',
      dataIndex: 'total_blt',
      key: 'total_blt',
      render: text => (isNaN(text) ? 'N/A' : text),
    },
    {
      title: 'TOTAL KGS',
      dataIndex: 'total_kgs',
      key: 'total_kgs',
      render: text => (isNaN(text) ? 'N/A' : text),
    },
  ];


  useEffect(() => {
    if (
      pressValue &&
      form.getFieldValue('cut_length') &&
      form.getFieldValue('plan_pcs') &&
      form.getFieldValue('last_wt_mtr') &&
      form.getFieldValue('cavity') &&
      form.getFieldValue('tool_number')
    ) {

      const newData = generateRange(
        form.getFieldValue('cut_length'),
        form.getFieldValue('plan_pcs'),
        form.getFieldValue('last_wt_mtr'),
        form.getFieldValue('cavity'),
        pressValue
      );

      setTableData(newData);
    }
  }, [pressValue, toolStatus, form]);

  const generateRange = (cutLength, planPcs, lastWeightKgMeter, cavity, press) => {
    if (!cutLength || !cavity || !lastWeightKgMeter || !planPcs) {
      console.warn('Missing required parameters:', {
        cutLength: !!cutLength,
        cavity: !!cavity,
        lastWeightKgMeter: !!lastWeightKgMeter,
        planQty: !!planPcs
      });
      return [];
    }
    if (!press || (!press.includes('P1') && !press.includes('P2'))) {
      console.warn('Press value not set or invalid:', press);
      return [];
    }

    let range = {};
    if (press.includes('P1')) {
      range = {
        start: 200,
        end: 670,
        sizes: [
          250, 300, 310, 350, 360, 390, 400, 410, 415, 430, 450, 460, 470,
          480, 490, 495, 505, 520, 530, 540, 545, 550, 560, 570, 580, 590, 610,
          620, 630, 640, 650, 660, 670,
        ],
      };
    } else if (press.includes('P2')) {
      range = {
        start: 200,
        end: 570,
        sizes: [
          250, 300, 310, 350, 360, 390, 400, 410, 415, 430, 450, 460, 470,
          480, 490, 505, 520, 530, 540, 545, 550, 560, 570,
        ],
      };
    }
    if (!range.sizes || range.sizes.length === 0) {
      console.warn('No range sizes defined for press value:', press);
      return [];
    }

    const safeDivide = (a, b, defaultValue = 0) => {
      if (b === 0 || isNaN(b)) return defaultValue;
      return a / b;
    };

    const safeNumber = (value, defaultValue = 0) => {
      const num = parseFloat(value);
      return isNaN(num) ? defaultValue : num;
    };

    const data = [];

    for (let i = 0; i < range.sizes.length; i++) {
      const bit_size = range.sizes[i];

      let bit_wt, butt_wt, act_wt, ext_len, star_one, star_two, pcs_bit, net_out,
        process_recovery, total_wastage, total_blt, total_kgs;

      if (press.includes('Press 1')) {
        bit_wt = safeNumber((bit_size * 0.034).toFixed(1));
        butt_wt = safeNumber((bit_wt * 0.04).toFixed(1));
        act_wt = safeNumber((bit_wt - butt_wt).toFixed(1));
        ext_len = safeDivide(safeDivide(act_wt, lastWeightKgMeter), cavity,);
        star_one = safeDivide(ext_len.toFixed(2), cutLength / 1000);
        star_two = parseInt(star_one);
        pcs_bit = star_two * cavity;
        net_out = pcs_bit * lastWeightKgMeter * (cutLength / 1000);
        process_recovery = safeDivide(net_out, bit_wt) * 100;
        total_wastage = (star_one.toFixed(2) - star_two) * cutLength;
        total_blt = safeDivide(planPcs, lastWeightKgMeter * pcs_bit * (cutLength / 1000),);
        total_kgs = total_blt * bit_wt;
      } else if (press.includes('Press 2')) {
        bit_wt = safeNumber((bit_size * 0.024).toFixed(1));
        butt_wt = safeNumber((bit_wt * 0.04).toFixed(1));
        act_wt = safeNumber((bit_wt - butt_wt).toFixed(1));
        ext_len = act_wt / lastWeightKgMeter / cavity;;
        star_one = safeDivide(ext_len.toFixed(2), cutLength / 1000);
        star_two = parseInt(star_one);
        pcs_bit = star_two * cavity;
        net_out = pcs_bit * lastWeightKgMeter * (cutLength / 1000);
        process_recovery = safeDivide(net_out, bit_wt) * 100;
        total_wastage = (Number(star_one.toFixed(4)) - star_two) * cutLength;
        total_blt = safeDivide(planPcs, lastWeightKgMeter * pcs_bit * (cutLength / 1000));
        total_kgs = total_blt * bit_wt;
      }

      data.push({
        id: `${bit_size}-${i}`,
        bit_size,
        bit_wt: safeNumber(bit_wt).toFixed(1),
        butt_wt: safeNumber(butt_wt).toFixed(1),
        act_wt: safeNumber(act_wt).toFixed(1),
        ext_len: safeNumber(ext_len).toFixed(2),
        star_one: safeNumber(star_one).toFixed(2),
        star_two: safeNumber(star_two),
        pcs_bit: safeNumber(pcs_bit),
        net_out: safeNumber(net_out).toFixed(1),
        process_recovery: safeNumber(process_recovery).toFixed(2),
        total_wastage: safeNumber(total_wastage).toFixed(0),
        total_blt: safeNumber(total_blt).toFixed(0),
        total_kgs: safeNumber(total_kgs).toFixed(0)
      });
    }
    return data;
  };


  const fetchAgingOptions = async (alloyId, temperId) => {
    if (!alloyId || !temperId) return;

    try {
      const response = await dispatch(
        fetchAgeingOptionsById({ alloyId, temperId }),
      );
      if (response?.payload?.length > 0) {
        const agingData = response.payload[0]; // Extract first object from response payload
        setAgingOptions(agingData); // Store response data in state
        form.setFieldsValue({ aging_value: agingData.aging_value }); // Update form field
        setAgeingResponse(null);
      } else {
        setAgeingResponse('No Aging Found');
        setAgingOptions(null);
        form.setFieldsValue({ aging_value: '' }); // Reset field if no data
      }
    } catch (error) {
      console.error('Error fetching aging options:', error);
      setAgingOptions(null);
      form.setFieldsValue({ aging_value: '' });
    }
  };

  const handleSelectTool = async (tool) => {

    if (tool) {
      const fetchDieCavity = tool.die_cavity;
      const fetchLastWTKGMT = tool.current_kg;
      const eligibleForPress = tool.eligible_for_press.id;
      const press = tool.eligible_for_press.name;
      setSelectedPressValue(press);
      setSelectedPress(tool?.eligible_for_press);

      form.setFieldsValue({
        cavity: fetchDieCavity,
        last_wt_mtr: fetchLastWTKGMT,
        eligible_for_press: eligibleForPress,
        tool_number: tool?.id,
      });
      setToolStatus({
        cavity: fetchDieCavity,
        press: press,
      });
    }
  };

  const handleSearchDieGroup = value => {
    setSearchGroup(value);
    if (value) {
      dispatch(fetchDieToolDetails({ page: 1, pagesize: 1000, search: value }));
    } else {
      dispatch(fetchDieToolDetails({ page: 1, pagesize: 10 }));
    }
  };

  const onScrollDiePress = async event => {
    const target = event.target;
    if (
      !diePressLoading &&
      diePressHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchDiePressList({ page: diePressCurrentPage, pagesize: 10 }));
    }
  };

  const handleSearchDiePress = value => {
    setSearchDiePress(value);
    if (value) {
      setSearchDiePress(value);
      dispatch(resetDiePressList());
      dispatch(fetchDiePressList({ page: 1, pagesize: 10, search: value }));
    } else {
      setSearchDiePress('');
      dispatch(resetDiePressList());
      dispatch(resetCurrentDiePressPage());
      dispatch(fetchDiePressList({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeDiePress = value => {
    // Log the selected value
    setSearchDiePress(value);
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Edit Planning</h2>
              <div className="bredcrumbwrp">
                <Link to="/planning-list" className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to="/planning-list">Planning</Link> },
                    { title: 'Edit Planning' },
                  ]}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="formwrapper">
        <Form form={form} layout="vertical" onFinish={onFinish} onValuesChange={handleFormChange}>
          <Row gutter={24}>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Profile No"
                name="profile_no"
                rules={[
                  { required: true, message: 'Please select a profile no' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Profile No"
                  style={{ width: '100%' }}
                  labelInValue
                  disabled
                  open={false}              // 👈 prevents dropdown
                  showSearch={false}        // 👈 no search
                  dropdownRender={() => null} // 
                >

                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                name="workorder"
                label="Work Order"

              >
                <AutoOpenSelect
                  placeholder="Order No - Order Date - PO Number - PO Date - Customer Name"
                  disabled
                  open={false}              // 👈 prevents dropdown
                  showSearch={false}        // 👈 no search
                  dropdownRender={() => null} // 
                >
                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item name="tool_number" label="Profile Tool">
                <AutoOpenSelect
                  placeholder="Tool No"
                  optionFilterProp="children"
                  onChange={(value, option) => {
                    form.setFieldValue('tool_number', value); // ID stored in form
                    handleSelectTool(option.tool);            // FULL OBJECT
                  }}
                  rules={[
                    { required: true, message: 'Please Select Die Tool!' },
                  ]}
                >
                  {toolList.map(tool => (
                    <Option key={tool?.id} value={tool?.id} tool={tool}>
                      {`${tool?.die?.die_number} - ${tool?.tool_number} - ${tool?.eligible_for_press?.name}`}
                    </Option>
                  ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Cut Length"
                name="cut_length"
                rules={[
                  { required: true, message: 'Please enter Cut Length!' },
                ]}
              >
                <Input placeholder="Cut Length" disabled />
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Work Order Date"
                name="workorder_date"
              >
                <DatePicker className="w-full" disabled />
              </Form.Item>
            </Col>

            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Customer Name"
                name="customer_name"
              >
                <Input placeholder="Enter Customer Name" disabled />
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item label="Alloy" name="alloy">
                <AutoOpenSelect
                  placeholder="Select Alloy"
                  labelInValue
                  disabled
                  open={false}
                  dropdownRender={() => null}
                >
                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item label="Temper" name="temper">
                <AutoOpenSelect
                  placeholder="Select Temper"
                  labelInValue
                  disabled
                  open={false}
                  dropdownRender={() => null}
                >

                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Color Code/Grade"
                name="color_code"
              >
                <Input placeholder="Enter Color Code/Grade" disabled />
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Order PCS"
                name="order_pcs"
                rules={[
                  {
                    pattern: /^[0-9]+$/, // Only allows numbers
                    message: 'Only numbers are allowed!',
                  },
                ]}
              >
                <Input type="primary" placeholder="Enter Order PCS" disabled />
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Order QTY"
                name="order_qty"
              >
                <Input type="primary" placeholder="Enter Order QTY" disabled />
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Planning Date"
                name="planning_date"
                rules={[
                  { required: true, message: 'Please select Planning Date.' },
                ]}
              >
                <DatePicker className="w-full" disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>

            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Plan PCS"
                name="plan_pcs"
                rules={[
                  {
                    required: true,
                    message: 'Please enter Plan PCS',

                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Enter Plan PCS"
                  maxLength={10}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    setTimeout(() => handleConversionChange('plan_pcs', value), 0);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Plan QTY"
                name="plan_qty"
                rules={[
                  {
                    required: true,
                    message: 'Please enter plan qty',
                  }
                ]}
              >
                <Input
                  placeholder="Enter Plan QTY"
                  value={planQtyInput}
                  onChange={(e) => {
                    const rawValue = e.target.value;
                    setPlanQtyInput(rawValue);
                    if (programmaticUpdate.current) {
                      programmaticUpdate.current = false;
                      return;
                    }

                    if (rawValue === '' || /^\d*\.?\d*$/.test(rawValue)) {
                      const value = parseFloat(rawValue);
                      if (!isNaN(value)) {
                        setTimeout(() => handleConversionChange('plan_qty', value), 0);
                        // if (workOrderStats.cutLength && toolStatus.cavity) {
                        //   console.log("Call here")
                        //   const newData = generateRange(
                        //     workOrderStats.cutLength,
                        //     workOrderStats.totalQty,
                        //     toolStatus.cavity,
                        //     toolStatus.Wtkgmt,
                        //     toolStatus.press,

                        //   );
                        //   setTableData(newData);
                        // }
                      }
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                name="quenching_type"
                label="Quenching Type"
                rules={[{ required: true, message: 'Please select quenching type' }]}
              >
                <Select placeholder="Select Quenching Type">
                  <Select.Option value="AIR">Air Quench</Select.Option>
                  <Select.Option value="WATER_SPRAY">Water Spray Quench</Select.Option>
                  <Select.Option value="MIST">Mist / Fog Quench</Select.Option>
                  <Select.Option value="WATER_DIP">Water Dip Quench</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Form.Item
              shouldUpdate={(prev, curr) => prev.quenching_type !== curr.quenching_type}
              noStyle
            >
              {({ getFieldValue }) => {
                const quenchType = getFieldValue('quenching_type');

                return ['WATER_SPRAY', 'MIST', 'WATER_DIP'].includes(quenchType) ? (
                  <>
                    <Col xs={24} sm={12} xl={8} xxl={4}>
                      <Form.Item
                        name="water_pressure"
                        label="Water Pressure (bar)"
                        rules={[{ required: true, message: 'Enter water pressure' }]}
                      >
                        <Input type="number" min={0} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} xl={8} xxl={4}>
                      <Form.Item
                        name="flow_rate"
                        label="Flow Rate (LPM)"
                        rules={[{ required: true, message: 'Enter flow rate' }]}
                      >
                        <Input type="number" min={0} />
                      </Form.Item>
                    </Col>
                  </>
                ) : null;
              }}
            </Form.Item>
            <Col xs={12} sm={8} lg={6} xxl={4}>
              <Form.Item
                label="Aging"
                name="aging_value"
                rules={[{ required: false, message: 'Please select Aging.' }]}
              >
                <Input placeholder="Enter Aging" />
                {cycleResponse && agingResponse !== null && <label style={{ fontSize: "1.3rem", color: "red" }}>Aging Not Found. Please Enter</label>}
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Cavity"
                name="cavity"
              >
                <Input placeholder="Enter Cavity" disabled />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Last WT/MTR"
                name="last_wt_mtr"
              >
                <Input placeholder="Enter Last WT MTR" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name="eligible_for_press"
                label="Press"
              >
                <AutoOpenSelect
                  placeholder="Select Press"

                  disabled
                  loading={diePressLoading}
                  onPopupScroll={onScrollDiePress}
                  notFoundContent={
                    diePressLoading ? 'Loading...' : 'No options'
                  }
                  value={searchDiePress}
                  showSearch={true}
                  onSearch={handleSearchDiePress}
                  onChange={handleChangeDiePress}
                  allowClear
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  dropdownRender={menu => <>{menu}</>}
                >
                  {diePressList.map(el => (
                    <Option key={el.id} value={el.id}>
                      {el.name}
                    </Option>
                  ))}
                  {diePressLoading && <Option>Loading...</Option>}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={24}>
              <div className="widwrp" style={{ backgroundColor: '#f0fff0' }}>
                <div className="widtitle"></div>
                <div className="vidvaluerow">
                  <div>
                    <label style={{ fontSize: '1.3rem' }}>Profile No</label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {' '}
                      {plannigData?.profile_no?.die_number}
                    </span>
                  </div>
                  <div>
                    <label style={{ fontSize: '1.3rem' }}>Cavity</label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {' '}
                      {plannigData?.die_tool?.die_cavity || 'N/A'}
                    </span>
                  </div>
                  <div>
                    <label style={{ fontSize: '1.3rem' }}>Last WT/MTR</label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {' '}
                      {plannigData?.die_tool?.current_kg || 'N/A'}
                    </span>
                  </div>
                  <div>
                    <label style={{ fontSize: '1.3rem' }}>CUT LENGTH(mm)</label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {' '}
                      {plannigData?.workorder?.work_order_details[0]?.length || 'N/A'}
                    </span>
                  </div>
                  <div>
                    <label style={{ fontSize: '1.3rem' }}> Billet Size</label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {' '}
                      {selectedRowData?.bltSize}
                    </span>
                  </div>
                  <div>
                    <label style={{ fontSize: '1.3rem' }}>Total Billet</label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {' '}
                      {selectedRowData?.totalBillets}
                    </span>
                  </div>
                  <div>
                    <label style={{ fontSize: '1.3rem' }}>Total Wastage</label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {' '}
                      {selectedRowData?.totalWastage}
                    </span>
                  </div>
                  <div>
                    <label style={{ fontSize: '1.3rem' }}>No. of Pcs</label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {selectedRowData?.pcsPerBlt || 'N/A'}
                    </span>
                  </div>
                  <div>
                    <label style={{ fontSize: '1.3rem' }}>
                      Process Recovery(%)
                    </label>
                    <span
                      style={{
                        fontSize: '1.5rem',
                        wordBreak: 'break-all',
                        fontWeight: 'bold',
                      }}
                    >
                      {selectedRowData?.recovery || 'N/A'}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* <Table
            className="px-0"
            rowKey="id" // This should match the ID field in your data
            columns={columns}
            dataSource={tableData}
            rowSelection={rowSelection}
            pagination={false}
          /> */}
          <BilletPlanningTable
            lastWtPerMtr={form.getFieldValue("last_wt_mtr")}
            cutLengthMm={form.getFieldValue("cut_length")}
            cavity={form.getFieldValue("cavity")}
            planPcs={form.getFieldValue("plan_pcs")}
            press={selectedPress}
             existingRow={{ bltSize: plannigData?.selected_row?.bltSize }}
            onRowSelect={(row) => {
              setSelectedRowData(row)
              //setSelectedBillet(row); // store selected row
            }}
          />
          <div className="flex justify-end mt-5">
            <Form.Item>
              <Button disabled={selectedRowData === null} type="primary" htmlType="submit" icon={<PlusOutlined />}>
                Edit Planning
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default EditPlanning;